import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAnalytics } from "../../lib/analytics";
import { useClientTranslations } from "../../lib/i18n/client";
import styles from "./BottomNav.module.css";

const HOME_ROUTES = ["/", "/files", "/get-ready", "/track", "/share"];

const NAV_ITEMS: {
	key: string;
	icon: string;
	path: string;
	event: string;
}[] = [
	{
		key: "home",
		icon: "/images/bottom-black-nav-home.svg",
		path: "/",
		event: "bottom_nav_home_click",
	},
	{
		key: "journey",
		icon: "/images/bottom-black-nav-journey.svg",
		path: "/journey",
		event: "bottom_nav_journey_click",
	},
	{
		key: "chat",
		icon: "/images/bottom-black-nav-chat.svg",
		path: "/chat",
		event: "bottom_nav_chat_click",
	},
	{
		key: "communication",
		icon: "/images/bottom-black-nav-communication.svg",
		path: "/communication",
		event: "bottom_nav_communication_click",
	},
	{
		key: "education",
		icon: "/images/bottom-black-nav-education.svg",
		path: "/education",
		event: "bottom_nav_education_click",
	},
];

const HIDDEN_ROUTES = [
	"/login",
	"/callback",
	"/2fa",
	"/onboarding",
	"/onboarding/thank-you",
	"/invitation",
];

export function BottomNav() {
	const { t } = useClientTranslations("common");
	const location = useLocation();
	const navigate = useNavigate();
	const analytics = useAnalytics();

	const isHidden = HIDDEN_ROUTES.some((route) =>
		location.pathname.startsWith(route),
	);

	useEffect(() => {
		if (!isHidden) {
			document.documentElement.classList.add("has-bottom-nav");
		} else {
			document.documentElement.classList.remove("has-bottom-nav");
		}
		return () => {
			document.documentElement.classList.remove("has-bottom-nav");
		};
	}, [isHidden]);

	if (isHidden) {
		return null;
	}

	const handleNavClick = (path: string, event: string) => {
		analytics.logEvent(event);
		if (location.pathname !== path) {
			navigate(path);
		}
	};

	return (
		<nav className={styles.nav}>
			{NAV_ITEMS.map((item) => {
				const isActive =
					item.path === "/"
						? HOME_ROUTES.includes(location.pathname)
						: location.pathname === item.path ||
							location.pathname.startsWith(`${item.path}/`);
				return (
					<button
						key={item.key}
						type="button"
						className={`${styles.navItem} ${isActive ? styles.active : ""}`}
						onClick={() => handleNavClick(item.path, item.event)}
						aria-label={t(`navigation.${item.key}`)}
					>
						<img
							src={item.icon}
							alt={t(`navigation.${item.key}`)}
							className={styles.navIcon}
						/>
					</button>
				);
			})}
		</nav>
	);
}
